import { render, staticRenderFns } from "./Hours.vue?vue&type=template&id=6f6f53c4&scoped=true&"
import script from "./Hours.vue?vue&type=script&lang=js&"
export * from "./Hours.vue?vue&type=script&lang=js&"
import style0 from "./Hours.vue?vue&type=style&index=0&id=6f6f53c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6f53c4",
  null
  
)

export default component.exports